import { Modal } from "@mui/material";
import "./styles.css";
import { DataGrid } from "@mui/x-data-grid";
const DSBillDetailsModal = ({ open = true, data = [], close }) => {
  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  const columns = [
    { field: "request_id", headerName: "Request ID", flex: 1 },
    { field: "loc", headerName: "Store Code", flex: 1 },
    { field: "bill_no", headerName: "Bill No.", flex: 1 },
    { field: "item", headerName: "Item No.", flex: 1 },
    { field: "qty", headerName: "Quantity", flex: 1 },
    { field: "refund_amount", headerName: "Refund Amount", flex: 1 },
    { field: "create_date", headerName: "Create Date", flex: 1 },
  ];

  return (
    <Modal open={open}>
      <div className="approved-main">
        <div className="approved-container">
          {/* Header  */}
          <div className="approved-header">
            <span>Bill Details</span>
            <button className="dsRequestCloseBtn" onClick={close}>
              Close
            </button>
          </div>
        </div>
        <div className="approved-container">
          {data?.length === 0 ? (
            <div className="approved-no-data">
              <div>No data available</div>
            </div>
          ) : (
            <div className="approved-grid-wrapper ">
              <DataGrid
                rows={data}
                columns={columns}
                hideFooter
                disableRowSelectionOnClick
                rowHeight={42}
                className="billDetailsModal"
                getRowId={(row) => generateRandom()}
              />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default DSBillDetailsModal;
